module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "main-content"
  }, [_c('div', {
    staticClass: "main-banner"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-9"
  }, [_c('div', {
    staticClass: "carousel slide",
    attrs: {
      "id": "bs-slider",
      "data-ride": "carousel"
    }
  }, [_c('ol', {
    staticClass: "carousel-indicators"
  }, _vm._l((_vm.slide), function(row, index) {
    return _c('li', {
      class: [index == 0 ? 'active' : ''],
      attrs: {
        "data-target": "#bs-slider",
        "data-slide-to": 0
      }
    })
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "carousel-inner",
    attrs: {
      "role": "listbox"
    }
  }, _vm._l((_vm.slide), function(row, index) {
    return _c('div', {
      staticClass: "carousel-item",
      class: [index == 0 ? 'active' : '']
    }, [_c('img', {
      staticClass: "d-block img-fluid",
      attrs: {
        "src": 'https://admin.weddingsung.com/upload/slide/' + row.image_path,
        "alt": index
      }
    })])
  }), 0), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [_c('div', {
    staticClass: "articles-box exlink-box"
  }, [_c('a', {
    attrs: {
      ":href": '/Featured',
      "target": "_blink"
    }
  }, [_c('h5', {
    staticClass: "title"
  }, [_vm._v("頂上故事-" + _vm._s(_vm.article[0].title))]), _vm._v(" "), _c('span', {
    staticClass: "pub_date text-primary"
  }, [_vm._v("\n                                  " + _vm._s(_vm.article[0].created_at) + "\n                              ")]), _vm._v(" "), _c('router-link', {
    staticClass: "more_link",
    attrs: {
      "to": '/Featured'
    }
  }, [_vm._v("more")]), _vm._v(" "), _c('article', {
    staticClass: "article-editor"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.article[0].context)
    }
  })])], 1)]), _vm._v(" "), _vm._l((_vm.hot), function(row, index) {
    return _c('div', {
      staticClass: "articles-box exlink-box"
    }, [_c('a', {
      attrs: {
        "href": row.link,
        "target": "_blink"
      }
    }, [_c('h5', {
      staticClass: "title"
    }, [_vm._v("熱門話題-" + _vm._s(row.title))]), _vm._v(" "), _c('span', {
      staticClass: "pub_date text-primary"
    }, [_vm._v(_vm._s(row.created_at))]), _vm._v(" "), _c('article', {
      staticClass: "article-editor"
    }, [_c('p', {
      domProps: {
        "innerHTML": _vm._s(row.context)
      }
    })])])])
  }), _vm._v(" "), (_vm.songSpecial.id > 0) ? _c('div', {
    staticClass: "articles-box exlink2"
  }, [_c('a', {
    attrs: {
      "href": '/topicview/' + _vm.songSpecial.id
    }
  }, [_c('h5', {
    staticClass: "title"
  }, [_vm._v("特別企劃")]), _vm._v(" "), _c('span', {
    staticClass: "sub-title  text-primary"
  }, [_vm._v(_vm._s(_vm.songSpecial.title))]), _vm._v(" "), _c('article', {
    staticClass: "article-image"
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": 'https://admin.weddingsung.com/upload/song/' + _vm.songSpecial.image_path
    }
  })])])]) : _vm._e()], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "main-block"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "bck-index bck-articles bck-index-bg"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "articles-items"
  }, [_vm._l((_vm.songLatest), function(row, index) {
    return _c('div', {
      staticClass: "articles-box refsongs-box"
    }, [(index === 0) ? _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-5"
    }, [_c('div', {
      staticClass: "embed-responsive embed-responsive-16by9"
    }, [_c('iframe', {
      staticClass: "embed-responsive-item",
      attrs: {
        "src": _vm.songLatest[0].link
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-7"
    }, [_c('div', {
      staticClass: "text"
    }, [_c('h5', {
      staticClass: "title"
    }, [_vm._v(_vm._s(_vm.songLatest[0].title))]), _vm._v(" "), _c('span', {
      staticClass: "pub_date text-primary"
    }, [_vm._v(_vm._s(_vm.songLatest[0].updated_at))]), _vm._v(" "), _c('article', {
      staticClass: "article-editor"
    }, [_c('p', {
      staticClass: "txt"
    }, [_vm._v("\n                                                    " + _vm._s(_vm._f("doubledot")(_vm._f("truncate")(_vm.songLatest[0].context, 250))) + "\n                                                ")])]), _vm._v(" "), _c('a', {
      staticClass: "btn btn-outline-primary btn-sm",
      attrs: {
        "href": '/songs/' + _vm.songLatest[0].id
      }
    }, [_vm._v("MORE")])])])]) : _vm._e()])
  }), _vm._v(" "), _vm._l((_vm.songLatest), function(row, index) {
    return _c('div', {
      staticClass: "articles-box refsongs-box"
    }, [(index === 1) ? _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-5 push-md-7"
    }, [_c('div', {
      staticClass: "embed-responsive embed-responsive-16by9"
    }, [_c('iframe', {
      staticClass: "embed-responsive-item",
      attrs: {
        "src": row.link
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-7 pull-md-5"
    }, [_c('div', {
      staticClass: "text"
    }, [_c('h5', {
      staticClass: "title"
    }, [_vm._v(_vm._s(row.title))]), _vm._v(" "), _c('span', {
      staticClass: "pub_date text-primary"
    }, [_vm._v(_vm._s(row.updated_at))]), _vm._v(" "), _c('article', {
      staticClass: "article-editor"
    }, [_c('p', {
      staticClass: "txt"
    }, [_vm._v("\n                                                  " + _vm._s(_vm._f("doubledot")(_vm._f("truncate")(row.context, 250))) + "\n                                                ")])]), _vm._v(" "), _c('a', {
      staticClass: "btn btn-outline-primary btn-sm",
      attrs: {
        "href": '/songs/' + row.id
      }
    }, [_vm._v("MORE")])])])]) : _vm._e()])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "bck-index bck-articles"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "articles-items"
  }, [_c('div', {
    staticClass: "articles-box refsongs-box ref-hn"
  }, _vm._l((_vm.SongShare), function(row, index) {
    return _c('div', {
      staticClass: "row",
      staticStyle: {
        "margin-bottom": "20px"
      }
    }, [_c('div', {
      staticClass: "col-md-5"
    }, [_c('div', {
      staticClass: "embed-responsive embed-responsive-16by9"
    }, [_c('iframe', {
      staticClass: "embed-responsive-item",
      attrs: {
        "src": row.link
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-7"
    }, [_c('div', {
      staticClass: "text"
    }, [_c('h5', {
      staticClass: "title"
    }, [_vm._v(_vm._s(row.title))]), _vm._v(" "), _c('span', {
      staticClass: "pub_date text-primary"
    }, [_vm._v(_vm._s(row.created_at))]), _vm._v(" "), _c('article', {
      staticClass: "article-editor"
    }, [_c('p', [_vm._v(_vm._s(_vm._f("doubledot")(row.context)))])]), _vm._v(" "), _c('a', {
      staticClass: "btn btn-outline-primary btn-sm",
      attrs: {
        "href": '/songs/' + row.song_id
      }
    }, [_vm._v("MORE")])])])])
  }), 0)])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "main-block"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "bck-index bck-articles"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "articles-items"
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.songCategory), function(row, index) {
    return _c('div', {
      staticClass: "col-lg-4 col-md-6"
    }, [_c('div', {
      staticClass: "articles-box catalog-box"
    }, [(row.id == 6) ? _c('a', {
      attrs: {
        "href": '/topic/'
      }
    }, [_c('figure', {
      staticClass: "pic articles-pic fitimg"
    }, [_c('img', {
      staticClass: "img-fluid",
      attrs: {
        "src": 'https://admin.weddingsung.com/upload/song/' + row.image_path
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "text"
    }, [_c('h5', {
      staticClass: "title"
    }, [_vm._v(_vm._s(row.title) + " (" + _vm._s(row.qty) + ")")]), _vm._v(" "), _c('article', {
      staticClass: "article-editor",
      domProps: {
        "innerHTML": _vm._s(row.context)
      }
    })])]) : _c('a', {
      attrs: {
        "href": '/songCategory/' + row.id
      }
    }, [_c('figure', {
      staticClass: "pic articles-pic fitimg"
    }, [_c('img', {
      staticClass: "img-fluid",
      attrs: {
        "src": 'https://admin.weddingsung.com/upload/song/' + row.image_path
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "text"
    }, [_c('h5', {
      staticClass: "title"
    }, [_vm._v(_vm._s(row.title) + " (" + _vm._s(row.qty) + ")")]), _vm._v(" "), _c('article', {
      staticClass: "article-editor",
      domProps: {
        "innerHTML": _vm._s(row.context)
      }
    })])])])])
  }), 0)])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "carousel-control-prev",
    attrs: {
      "href": "#bs-slider",
      "role": "button",
      "data-slide": "prev"
    }
  }, [_c('span', {
    staticClass: "carousel-control-prev-icon",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Previous")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "carousel-control-next",
    attrs: {
      "href": "#bs-slider",
      "role": "button",
      "data-slide": "next"
    }
  }, [_c('span', {
    staticClass: "carousel-control-next-icon",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Next")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "title"
  }, [_c('span', [_vm._v("本週推薦歌曲")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "title title-bg-flowers"
  }, [_c('span', [_vm._v("歌曲使用分享")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "title title-bg-music"
  }, [_c('span', [_vm._v("精選分類")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0096e913","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Home.vue
// module id = 152
// module chunks = 1